var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.354 12.687 3 13.5a.5.5 0 0 1-.5-.5c.285-.768.522-1.583.833-2.333a.5.5 0 0 1 .109-.162l7.5-7.5a.5.5 0 0 1 .707 0L13 4.333a.5.5 0 0 1 0 .707l-7.646 7.647ZM9.333 4.833l1.834 1.834","stroke":"currentColor","strokeWidth":"1.333","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Pencil.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = Pencil;

Pencil.default = Pencil;
